import emoji from 'react-easy-emoji'
import styles from './styles.module.scss'
import clsx from 'clsx'

function EmojiMessage({ title, renderRepliedMsgPreview, content = '', renderEditedMsgSubtitle, className, type }) {
  return (
    <div data-type={type} title={title} className={clsx(styles.emoji_message, className)}>
      {renderRepliedMsgPreview}
      {emoji(content)}
      {renderEditedMsgSubtitle}
    </div>
  )
}

export default EmojiMessage
